export default "__VITE_ASSET__V809TsfU__"